<template>
  <div style="padding: 20px 20px 20px 20px; background: #fff; border-radius: 10px">
    <div>
      <div class="top-div">
        <h4 class="title">物流园停靠次数top100企业情况</h4>
        <div class="privice-tiem">
          <span class="demonstration">统计月份 </span>
          <el-date-picker
              v-model="monTime"
              type="month"
              placeholder="选择月"
              @change="changeTime"
              value-format="yyyy-MM"
          ></el-date-picker>
          <el-button @click="goback">返回上一级</el-button>
        </div>
      </div>
      <el-table
          ref="singleTable"
          :data="tableData"
          :max-height="tableHeight1"
          stripe
          style="width: 100%"
      >
        <el-table-column
            type="index"
            width="50"
            label="序号 "
            align="center"
        ></el-table-column>
        <el-table-column
            property="companyName"
            label="停靠企业名称"
            width="200"
            align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
                v-if="scope.row.isDecryption"
                placement="top"
                content="点击解密"
            >
              <span style="cursor: pointer" @click="clickRow(scope.row)">{{
                  scope.row.companyName
                }}</span>
            </el-tooltip>
            <span v-else>{{ scope.row.isDecryptionName }}</span>
          </template>
        </el-table-column>
        <el-table-column property="companyAddress" label="地址" width="300" align="center">
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="200" label="全部车辆停靠次数(次)">
          <template slot-scope="scope">
            {{ $format(scope.row.stopCount) }}
          </template>
        </el-table-column>
        <!--        <el-table-column property="stopCarNum" label="停靠车辆数" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{ $format(scope.row.stopCarNum) }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column property="stopNum" align="center" width="200" label="柴油车辆停靠次数(次)">
          <template slot-scope="scope">
                {{ $format(scope.row.dieStopCount) }}
          </template>
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="200" label="电车辆停靠次数(次)">
          <template slot-scope="scope">
                {{ $format(scope.row.eleStopCount) }}
          </template>
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="200" label="氢车辆停靠次数(次)">
          <template slot-scope="scope">
                {{ $format(scope.row.hydStopCount) }}
          </template>
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="200" label="其他车辆停靠次数(次)">
          <template slot-scope="scope">
                {{ $format(scope.row.otherStopCount) }}
          </template>
        </el-table-column>
        <el-table-column property="companyCarNumLevel" label="企业总车辆区间" width="150" align="center"></el-table-column>
        <el-table-column property="stopNum" align="center" width="150" label="柴油车辆占比">
          <template slot-scope="scope">
                {{ $format(scope.row.dieStopRatio)+'%' }}
          </template>
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="150" label="电车辆占比">
          <template slot-scope="scope">
                {{ $format(scope.row.eleStopRatio)+'%' }}
          </template>
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="150" label="氢车辆占比">
          <template slot-scope="scope">
                {{ $format(scope.row.hydStopRatio)+'%' }}
          </template>
        </el-table-column>
        <el-table-column property="stopNum" align="center" width="150" label="其他车辆占比">
          <template slot-scope="scope">
                {{ $format(scope.row.otherStopRatio)+'%' }}
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          property="companyCarNum"-->
        <!--          label="企业总车辆数"-->
        <!--          align="center"-->
        <!--          width="160"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            {{ scope.row.companyCarNumLevel }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight'
import Cookies from 'js-cookie'
import {getFuelTypeList, getFuelTypeCode} from '@/utils/dictionary'
import each from 'lodash/each'
// import { threadId } from 'worker_threads'
export default {
  data() {
    let fuelTypeList = getFuelTypeList()
    return {
      fuelTypeList,
      tableHeight1: this.tableHeight + 80,
      monTime: '', // 默认月份
      tableData: [],
      // moduleName: 'wuliuCollectionStat',
      moduleName: 'wuliuCollectionStatV2',
      type: 0,
      newmoth: ''
    }
  },
  props: ['poiId', 'value4'],
  mounted() {
    this.moren()
    this.type = Cookies.get('userType')

  },
  methods: {
    async moren() {
      console.log(this.value4)
      var that = this
      let year = this.value4.split("-")[0]
      let month = this.value4.split("-")[1]
      let moduleName = this.moduleName
      let params = {
        moduleName,
        year,
        provinceCode: '',
        provinceName: '',
        region: '',
        brand: '',
        pathwayCityCode: '',
        roadCode: ''
      }
      let {data} = await http.carLogiDetalMonth(params)
      let dataMon = data.reverse()
      console.log(dataMon)
      for (let it of dataMon) {
        if (it.includes('ok')) {
          month = it.substring(0, 2)
          this.monTime = year + '-' + month
          that.getDatails()
          return
        }
      }
      // this.monTime = year + '-' + month
      // that.getDatails()


    },
    changeFuelType() {
      this.getDatails()
    },
    async clickRow(obj) {
      obj.isDecryption = false
      let {code, data} = await http.carLogiDetalDecrypt2({id: obj.id})
      if (code !== 200) return
      obj.isDecryptionName = '' + data.companyName
    },
    async getDatails() {
      var that = this
      let year = that.monTime.split('-')[0]
      let month = that.monTime.split('-')[1]
      let params = {
        year,
        month,
        poiId: that.poiId
      }
      let {code, data} = await http.carLogiDetal2(params)
      if (code != 200) return
      each(data, it => {
        it.isDecryption = true
        it.isDecryptionName = ''
      })
      that.tableData = data
    },
    changeTime() {
      this.getDatails()
    },
    goback() {
      this.$emit('closeDetails')
    }
  }
}
</script>
